import { useEffect, useState } from "react";
import AdditionalInfo from "./profile/AdditionalInfo";
import logo from "../assets/icon-interests.png";
import { Field } from "@bwevents/components";
import "./DialogInterest.scss";

export default function DialogInterest({
  api,
  account,
  messenger,
  setAccount,
  emmitCheckHideDialog,
}) {
  const [hideDialog, setHideDialog] = useState(false);

  useEffect(() => {
    emmitCheckHideDialog(hideDialog);
  }, [hideDialog, emmitCheckHideDialog]);

  return (
    <div className="dialog-interest">
      <div className="dialog-interest-header mb-1">
        <img src={logo} alt="interests" />
        <div className="info">
          <h2>We aim to be interesting</h2>
          <p>
            With a more comprehensive profile, we will suggest more tailored
            recommendations based on your preferences.
          </p>
        </div>
      </div>
      <AdditionalInfo
        api={api}
        account={account}
        messenger={messenger}
        setAccount={setAccount}
        canEditState={true}
        layout={"modal"}
      />
      <hr />
      <Field
        className="bw-event-checkbox mb-0 mt-3"
        type="checkbox"
        label="Dont show it again. I’ll add this info in my later in my profile"
        value={hideDialog}
        setValue={setHideDialog}
      />
    </div>
  );
}
